if (!customElements.get('live-watching')) {
  customElements.define(
    'live-watching',
    class LiveWatching extends HTMLElement {
      static pool = new Set();
      static moving = false;

      connectedCallback() {
        this.countEl = this.querySelector('[data-live-count]');
        this.min = Number(this.dataset.min) || 0;
        this.max = Number(this.dataset.max) || 13;
        this.pace = Number(this.dataset.pace) || 4000;
        this.count = Number(this.dataset.count) || 0;
        this.productId = Number(this.dataset.productId) || 1;
        this.render();

        if (this.classList.contains('live-watching--compact')) {
          LiveWatching.pool.add(this);
          LiveWatching.startMoving();
        } else {
          this.schedule();
        }
      }

      schedule() {
        const jitter = this.pace * (0.45 + Math.random());
        this.timer = setTimeout(() => this.nudge(), jitter);
      }

      nudge() {
        let step = Math.random() < 0.3 ? 2 : 1;
        let direction = Math.random() < 0.5 ? -1 : 1;
        if (this.count <= this.min + 1) direction = 1;
        if (this.count >= this.max - 1) direction = -1;
        this.count = Math.min(this.max, Math.max(this.min, this.count + direction * step));
        this.render();
        this.schedule();
      }

      setCount(next) {
        this.count = Math.max(0, Math.min(this.max, next));
        this.render();
      }

      render() {
        this.classList.toggle('is-empty', this.count < 1);
        if (this.countEl && this.count > 0) this.countEl.textContent = String(this.count);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        LiveWatching.pool.delete(this);
      }

      static startMoving() {
        if (this.moving) return;
        this.moving = true;
        this.queueMove();
      }

      static queueMove() {
        this.moveTimer = setTimeout(() => {
          this.shiftViewers();
          this.queueMove();
        }, 2500 + Math.random() * 3500);
      }

      static shiftViewers() {
        const groups = new Map();
        for (const el of this.pool) {
          if (!groups.has(el.productId)) groups.set(el.productId, []);
          groups.get(el.productId).push(el);
        }
        const ids = [...groups.keys()];
        if (ids.length < 2) return;

        const withPeople = ids.filter((id) => groups.get(id)[0].count > 0);
        if (!withPeople.length) return;

        const fromId = withPeople[Math.floor(Math.random() * withPeople.length)];
        let toId = ids[Math.floor(Math.random() * ids.length)];
        if (toId === fromId) {
          toId = ids.find((id) => id !== fromId) || fromId;
        }
        if (toId === fromId) return;

        const fromEls = groups.get(fromId);
        const toEls = groups.get(toId);
        const fromCount = fromEls[0].count;
        const toCount = toEls[0].count;
        const room = Math.max(0, toEls[0].max - toCount);
        if (room < 1) return;

        let amount = 1;
        if (fromCount > 4 && Math.random() < 0.35) amount = 2;
        if (Math.random() < 0.12) amount = fromCount;
        amount = Math.min(amount, fromCount, room);

        const nextFrom = fromCount - amount;
        const nextTo = toCount + amount;
        fromEls.forEach((el) => el.setCount(nextFrom));
        toEls.forEach((el) => el.setCount(nextTo));
      }
    }
  );
}
